// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-size: 40px;
  background-color: '#f7f7f8 !important';
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(40px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.switch-container > * {
  margin-left: 10px;
  margin-right: 10px;
}

.switch-container {
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* margin-top: 10px; */
}

.switch-container h5.my-subscription-name {
  font-weight: normal;
  color: #333333;
  font-size: 20px !important;
  min-width: 126px;
}

.mask-box {
  border-radius: 36px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 2px;
  position: relative;
  background: #f0f0f0;
  box-shadow: 1px 1px 2px rgb(165, 165, 165) inset;
}
.mask-box .mask {
  width: 75px;
  height: 32px;
  border-radius: 230px;
  background: #7f59e5;
  position: absolute;
  transition: all 0.5s ease;
}
.mask-box .MuiButton-root {
  border-radius: 230px;
  width: 75px;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  transition: all 0.2s 0.1s ease;
}
.mask-box .MuiButton-root:hover {
  opacity: 0.8;
}
.underline-anchor > a {
  text-decoration: underline !important;
}

.checkbox-menu > p {
  font-weight: 400;
  font-size: 14px;
  margin: 12px;
}

.checkbox-menu {
  margin-top: 12px;
}
.checkbox-menu svg {
  min-width: 20px;
}

div.choose-billing-container {
  margin-top: 30px;
}
.small-font {
  font-size: 16px;
}

.red {
  color: #eb4a4a !important;
}

.childCard {
  align-self: stretch;
  border: 1px solid rebeccapurple;
  border-radius: 28px !important;
}

.innerTopContainer {
  min-height: 100px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.allCards {
  position: relative;
  margin-top: 60px;
}

@media (max-height: 860px) {
  .childCard {
    zoom: 0.9;
  }
}

@media (max-height: 800px) {
  .childCard {
    zoom: 0.8;
  }
}

@media (max-height: 730px) {
  .childCard {
    zoom: 0.7;
  }
}

@media (max-height: 600px) {
  .childCard {
    zoom: 0.6;
  }
}
@media (max-width: 480px) {
  body {
    overflow: auto !important;
  }
  .allCards {
    display: block !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n  font-size: 40px;\n  background-color: '#f7f7f8 !important';\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(40px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.switch-container > * {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.switch-container {\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  /* margin-top: 10px; */\n}\n\n.switch-container h5.my-subscription-name {\n  font-weight: normal;\n  color: #333333;\n  font-size: 20px !important;\n  min-width: 126px;\n}\n\n.mask-box {\n  border-radius: 36px;\n  border: 1px solid #e0e0e0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 2px;\n  position: relative;\n  background: #f0f0f0;\n  box-shadow: 1px 1px 2px rgb(165, 165, 165) inset;\n}\n.mask-box .mask {\n  width: 75px;\n  height: 32px;\n  border-radius: 230px;\n  background: #7f59e5;\n  position: absolute;\n  transition: all 0.5s ease;\n}\n.mask-box .MuiButton-root {\n  border-radius: 230px;\n  width: 75px;\n  height: 32px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  transition: all 0.2s 0.1s ease;\n}\n.mask-box .MuiButton-root:hover {\n  opacity: 0.8;\n}\n.underline-anchor > a {\n  text-decoration: underline !important;\n}\n\n.checkbox-menu > p {\n  font-weight: 400;\n  font-size: 14px;\n  margin: 12px;\n}\n\n.checkbox-menu {\n  margin-top: 12px;\n}\n.checkbox-menu svg {\n  min-width: 20px;\n}\n\ndiv.choose-billing-container {\n  margin-top: 30px;\n}\n.small-font {\n  font-size: 16px;\n}\n\n.red {\n  color: #eb4a4a !important;\n}\n\n.childCard {\n  align-self: stretch;\n  border: 1px solid rebeccapurple;\n  border-radius: 28px !important;\n}\n\n.innerTopContainer {\n  min-height: 100px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.allCards {\n  position: relative;\n  margin-top: 60px;\n}\n\n@media (max-height: 860px) {\n  .childCard {\n    zoom: 0.9;\n  }\n}\n\n@media (max-height: 800px) {\n  .childCard {\n    zoom: 0.8;\n  }\n}\n\n@media (max-height: 730px) {\n  .childCard {\n    zoom: 0.7;\n  }\n}\n\n@media (max-height: 600px) {\n  .childCard {\n    zoom: 0.6;\n  }\n}\n@media (max-width: 480px) {\n  body {\n    overflow: auto !important;\n  }\n  .allCards {\n    display: block !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
